import { StipendiumDisplayModelFormGroup, StipendiumDisplayModel } from '@/api/model-index';
import { AnfrageService } from '@/api/service-index';
import { AnfrageNavigationFormComponent, MoveDirection } from '@/core/components/anfrage-navigation-form/anfrage-navigation-form.component';
import { LoadingAnimationService } from '@/core/services/loading-animation.service';
import { PortalContextService } from '@/core/services/portal-context.service';
import { SectionService } from '@/core/services/section.service';
import { StateService } from '@/core/services/state.service';
import { UnfinishedHttpMethodsService } from '@/core/services/unfinished-http-methods.service';
import { convertJSDateString } from '@/core/utils/date-converter';
import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'stipendium-proccess-step',
  templateUrl: './stipendium-proccess-step.component.html',
  styleUrls: ['./stipendium-proccess-step.component.scss']
})
export class StipendiumProccessStepComponent extends AnfrageNavigationFormComponent {
  public stipendiumProcessStepForm: StipendiumDisplayModelFormGroup;
  public stipendium: StipendiumDisplayModel;

  public get formGroup(): FormGroup<any> {
    return this.stipendiumProcessStepForm;
  }

  constructor(
    protected sectionService: SectionService,
    protected route: ActivatedRoute,
    protected loadingAnimationService: LoadingAnimationService,
    protected router: Router,
    protected stateService: StateService,
    protected anfrageService: AnfrageService,
    protected portalContextService: PortalContextService,
    protected unfinishedHttpMethodsService: UnfinishedHttpMethodsService
  ) {
    super(sectionService, router, route, portalContextService);
    this.stipendiumProcessStepForm = StipendiumDisplayModelFormGroup.Instance;
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.anfrage = this.route.snapshot.data.anfrage;
    this.stipendium = this.route.snapshot.data.stipendium;
    this.stipendiumProcessStepForm.patchValue(this.stipendium);

    if (this.stipendium.studienbeginn)
      this.stipendiumProcessStepForm.Studienbeginn.patchValue(new Date(this.stipendium.studienbeginn));

    if (this.stipendium.studienende)
      this.stipendiumProcessStepForm.Studienende.patchValue(new Date(this.stipendium.studienende));
  }

  protected save(shouldSave: boolean, moveDirection: MoveDirection): void {
    let stipendium: StipendiumDisplayModel = this.stipendiumProcessStepForm.getRawValue();

    if (this.anfrage.stipendium && stipendium && shouldSave && this.stipendiumProcessStepForm.dirty) {
      stipendium.studienbeginn = convertJSDateString(stipendium.studienbeginn);
      stipendium.studienende = convertJSDateString(stipendium.studienende);

      delete this.portalContextService.CurrentAnfrage.stipendium;
      this.stipendiumProcessStepForm.markAsPristine();
      if (moveDirection != MoveDirection.STAY) {
        if (this.canceledRoute) {
          this.router.navigateByUrl(this.canceledRoute);
        } else {
          this.move(moveDirection);
        }
      }

      let subscription = this.anfrageService.apiAnfrageAnfrageIdStipendiumPatch({ anfrageId: this.anfrage.id, body: stipendium })
        .subscribe(() => {
          this.anfrageService.apiAnfrageAnfrageIdValidateGet({ anfrageId: this.anfrage.id }).subscribe(result => {
            this.stateService.ValidationErrors = result;
          })

          if (this.portalContextService.CurrentAnfrage)
            this.portalContextService.CurrentAnfrage.stipendium = stipendium;     

          this.stipendiumProcessStepForm.markAsPristine();
        });

      this.loadingAnimationService.showSpinnerUsingSubscription(subscription);
      this.unfinishedHttpMethodsService.addSubscription(subscription);
    } else {
      this.stipendiumProcessStepForm.markAsPristine();
      this.move(moveDirection);
    }
  }
}
